import { Emitter, Event } from "../../../../../features/event-emitter"
import { Data } from "../../../../../features/ui"
import { useDriverActions } from "../../../actions/driverActions"
import { useDriverBuilders } from "../../../builders/driverBuilders"

export const useActions = () => {
    const { buildDriver } = useDriverBuilders()
    const { saveDriver } = useDriverActions()

    const submitDriver = async (
        driverData: Data,
        createMode: boolean
    ) => {
        Emitter.emit(Event.DB_SUBMIT)

        const driver = buildDriver(driverData)
        await saveDriver(driver)
        Emitter.emit(Event.DB_SUBMIT_DONE, createMode)
    }
    
    return {
        submitDriver
    }
}
